import React, {Component} from 'react'
import ReactTable from "react-table";
import * as config from '../Configuration/Config.js'

class DashboardsGrid extends Component {
    constructor() {
        super();

        this.state = {
            loaded: false,
            dashboards: []
        }
    }

    componentDidMount() {
        var that = this;

        const uri = config.getUriPath('dashboards')
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }
            return response.json();
          })
          .then(function(data) {
            that.setState({ loaded: true, dashboards: data });
          });
    }

    render() {

        if (this.state.loaded === false){
            return <div></div>;
        }

        const dashboards = this.state.dashboards;

        if (dashboards === null || dashboards.length === 0) {
            return <div>
                    <div className="center-div">
                        <h1>All Dashboards</h1>
                    </div>
                    <br/><br/>
                    <h1>No Dashboards Found</h1>                
            </div>
        }

        return <div>
                <div className="center-div">
                    <h1>All Dashboards</h1>
                </div>
                <br/><br/>
                <div className="ReactTableCenter center-div">
                    <ReactTable
                        data={dashboards}                        
                        columns={[
                            {
                                Header: "Dashboard Name",
                                id: "id",
                                accessor: 'display_name',
                                Cell: (row) => 
                                    <span className="center-div">
                                        <a href={"/dashboards/view/" + row.original.id + "/" + row.original.group_id}>{row.original.display_name}</a>
                                    </span>                                
                            }
                        ]}
                        defaultPageSize={15}
                        className="-striped -highlight"
                    >
                    </ReactTable>
                </div>
        </div>
    }
}

export default DashboardsGrid


// WEBPACK FOOTER //
// ./src/Components/Dashboards/DashboardsGrid.js